// extracted by mini-css-extract-plugin
module.exports = {"hidden":"feedback_hidden__l2msH","textEmphasis":"feedback_textEmphasis__q5Fdw","feedbackArea":"feedback_feedbackArea__vJs6q","feedbackInner":"feedback_feedbackInner__ZP3U3"};